import classNames from 'classnames/bind';
import styles from './SearchEverywhere.module.scss';

const cx = classNames.bind(styles);

const continentList = [
  {
    continent: '1',
    continentId: '1',
    name: '동남아',
    clickCode: 'aseanall',
  },
  {
    continent: '2',
    continentId: '2,3',
    name: '일본, 중국',
    clickCode: 'eastasiaall',
  },
  {
    continent: '5',
    continentId: '5',
    name: '유럽',
    clickCode: 'euall',
  },
  {
    continent: '4',
    continentId: '4',
    name: '미주',
    clickCode: 'naall',
  },
  {
    continent: '6',
    continentId: '6',
    name: '남태평양',
    clickCode: 'ocall',
  },
  {
    continent: '10',
    continentId: '7,8,9,10',
    name: '아시아, 남미, 아프리카',
    clickCode: 'etcall',
  },
];

interface IProps {
  isNoResult?: boolean;
}

const SearchEverywhere = ({ isNoResult = false }: IProps) => {
  const handleEntireClick = (continentId?: string) => {
    location.href = `/flights/everywhere/monthly/SEL${continentId ? `?continents=${continentId}` : ''}`;
  };

  return (
    <div className={cx('SearchEverywhere', 'everywhere_list')}>
      <p className={cx('text')}>
        전세계 인기 도시별 가장 저렴한 항공편을 검색해 보세요.
      </p>
      <ul className={cx('list')}>
        <li className={cx('list_item')} data-type="worldwide" role="row">
          <button
            type="button"
            className={cx('link')}
            data-event-nlog="click"
            data-event-area-code={`arr.${isNoResult ? 'noresult' : 'every'}all`}
            onClick={() => handleEntireClick()}
          >
            전 세계 모든곳 검색
          </button>
        </li>
        {continentList.map(({ clickCode, continent, continentId, name }) => (
          <li
            className={cx('list_item')}
            data-event-nlog="click"
            data-event-area-code={`arr.${isNoResult ? 'noresult' : 'every'}${clickCode}`}
            data-type={continent}
            key={name}
          >
            <button
              type="button"
              className={cx('link')}
              onClick={() => handleEntireClick(continentId)}
            >
              {name}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SearchEverywhere;
